var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyersDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23623",
    transform: "translate(0 -192)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5439",
    width: 75,
    height: 75,
    rx: 15,
    transform: "translate(0 192)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "More icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16291",
    d: "M13.824 2.954a3.084 3.084 0 0 0-2.8-2.886 34.639 34.639 0 0 0-3.819-.02 35.717 35.717 0 0 0-3.83.343A3.71 3.71 0 0 0 .361 3.4a36.682 36.682 0 0 0-.343 3.835 33.5 33.5 0 0 0 .019 3.818 3.084 3.084 0 0 0 2.886 2.8c.938.076 2.217.13 3.972.125s3.038-.066 3.973-.151A3.229 3.229 0 0 0 13.8 10.9c.084-.935.146-2.218.151-3.973s-.05-3.036-.126-3.971z",
    transform: "translate(23.023 214.994)",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16292",
    d: "M287.122 3.374a3.711 3.711 0 0 0-3.014-3.013 36.679 36.679 0 0 0-3.831-.343 33.5 33.5 0 0 0-3.818.019 3.084 3.084 0 0 0-2.8 2.886c-.076.938-.13 2.217-.125 3.972s.066 3.038.151 3.973a3.228 3.228 0 0 0 2.93 2.93c.938.084 2.218.146 3.973.151s3.038-.049 3.972-.125a3.085 3.085 0 0 0 2.886-2.8 34.341 34.341 0 0 0 .019-3.818 35.69 35.69 0 0 0-.344-3.832z",
    transform: "translate(-234.506 215.023)",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16293",
    d: "M13.828 276.6a3.228 3.228 0 0 0-2.93-2.93c-.938-.084-2.218-.146-3.973-.151s-3.038.049-3.972.125a3.086 3.086 0 0 0-2.885 2.8 34.641 34.641 0 0 0-.019 3.818 35.709 35.709 0 0 0 .343 3.831A3.711 3.711 0 0 0 3.4 287.1a36.089 36.089 0 0 0 3.829.343 33.942 33.942 0 0 0 3.818-.019 3.085 3.085 0 0 0 2.8-2.887c.076-.934.13-2.217.125-3.972s-.064-3.041-.149-3.973z",
    transform: "translate(22.994 -42.489)",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16294",
    d: "M287.477 276.459a3.085 3.085 0 0 0-2.886-2.8c-.935-.076-2.217-.13-3.972-.125s-3.039.066-3.973.151a3.228 3.228 0 0 0-2.93 2.93c-.085.938-.146 2.218-.151 3.973s.049 3.038.125 3.972a3.085 3.085 0 0 0 2.8 2.886 34.338 34.338 0 0 0 3.818.019 35.629 35.629 0 0 0 3.829-.343 3.71 3.71 0 0 0 3.015-3.015 36.15 36.15 0 0 0 .343-3.829 35.01 35.01 0 0 0-.018-3.819z",
    transform: "translate(-234.536 -42.506)",
    style: {
      fill: "#7c7c7c"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyersDashboard);
export default __webpack_public_path__ + "static/media/buyers_dashboard.360bd6b19a1b4346853e6c53a8942aa2.svg";
export { ForwardRef as ReactComponent };